/* @flow */
import type { OptionsObject, FileFormat } from './types.js';
import {
  CLEAR_LIST,
  SET_CURRENT_ID,
  STORE,
  SET_DISPLAY_OPTIONS,
  REFETCH_REPORTS,
  REMOVE,
  SET_ATTRIBUTE,
  REMOVE_ATTRIBUTE,
  SET_ENCLAVE_TAG,
  REMOVE_ENCLAVE_TAG,
  REINDEX,
  STORE_FROM_LOCAL,
  EXPORT_REPORT,
  SET_ENCLAVE_TAGS_BULK,
  CLEAR_REPORT_METADATA_CACHE,
  FETCH_METADATA as FETCH_REPORT_METADATA,
  FETCH_METADATA_SUCCESS as FETCH_REPORT_METADATA_SUCCESS,
  FETCH_METADATA_FAILURE as FETCH_REPORT_METADATA_FAILURE,
} from './action-types.js';
import {COPY_REPORT, MOVE_REPORT} from './action-types';

import {SET_ENCLAVE_TAGS_BULK_SUCCESS} from './action-types';
/* Clears the report list */
export const clearReportList = () => ({ type: CLEAR_LIST });

/**
 * Refetches report list based on whatever the current display options are.
 *
 * NOTE: This clears the existing report list.
 */
export const refetchReportsList = () => ({ type: REFETCH_REPORTS });

/**
 * Set display options. Determines sorting and filtering of REPORTS.
 */
export const setDisplayOptions = (options: OptionsObject) => ({
  type: SET_DISPLAY_OPTIONS,
  payload: options,
});

export const fetchAndStore = (id: string) => ({
  type: STORE,
  payload: id,
});

/**
 * Store a report from another part of state, we are not conforming to report type because it may be partial
 * @param report, a map
 */
export const storeFromLocal = (report: Map<string, any>) => ({
  type: STORE_FROM_LOCAL,
  payload: report,
});

export const setEnclaveTag = (id: string, enclaveId: string, name: string) => ({
  type: SET_ENCLAVE_TAG,
  payload: { id, enclaveId, name },
});

export const setEnclaveTagsBulk = (id: string, enclaveIds: Array<string>, addedTags: Array<string> = [], removedTags: Array<string> = [], alertOnSuccess: boolean = true) => ({
  type: SET_ENCLAVE_TAGS_BULK,
  payload: { id, enclaveIds, addedTags, removedTags, alertOnSuccess},
});

export const setAttribute = (id: string, name: string) => ({
  type: SET_ATTRIBUTE,
  payload: { id, name },
});

export const setCurrentReportId = (id: string) => ({
  type: SET_CURRENT_ID,
  payload: id,
});

export const removeEnclaveTag = (reportId: string, tagName: string) => ({
  type: REMOVE_ENCLAVE_TAG,
  payload: { reportId, tagName },
});

export const removeAttribute = (reportId: string, tagName: string) => ({
  type: REMOVE_ATTRIBUTE,
  payload: { reportId, tagName },
});

export const removeReport = (id: string) => ({
  type: REMOVE,
  payload: id,
});

export const reindexReport = (id: string) => ({
  type: REINDEX,
  payload: id,
});

export const exportReport = (id: string, format: FileFormat) => ({
  type: EXPORT_REPORT,
  payload: { id, format },
});

export const copyReport = (payload: {reportId: string, destEnclaveGuid: string, copyFromProvidedSubmission?: boolean, reportJSON?: any}) => ({
  type: COPY_REPORT,
  payload,
});
export const moveReport = (payload: {reportId: string, destEnclaveGuid: string}) => ({
  type: MOVE_REPORT,
  payload,
});

/**
 * Report Metadata Cache Actions
 * Metadata cache is used to reduce calls to enrich reports with metadata
 **/

export const clearMetadataCache = () => ({
  type: CLEAR_REPORT_METADATA_CACHE,
});

export const fetchReportMetadata = (reportIds: Array<string>, cacheDisabled: boolean = false) => ({
  type: FETCH_REPORT_METADATA,
  payload: reportIds,
  meta: { cacheDisabled },
});

export const fetchReportMetadataSuccess = (reportMetadata: Array<Object>) => ({
  type: FETCH_REPORT_METADATA_SUCCESS,
  payload: reportMetadata,
});

export const fetchReportMetadataFailure = (
  error: Object,
  errorMessage: string = 'There was an error fetching report metadata',
) => ({
  type: FETCH_REPORT_METADATA_FAILURE,
  payload: error,
  error: true,
  meta: { type: 'error', text: errorMessage },
});



// WEBPACK FOOTER //
// ./src/app/modules/reports/actions.js